/**
 * Shared state for feature upgrade modal suppression.
 * This module exists to avoid circular dependency between
 * api/client.js and components/FeatureUpgradeModal.js
 */

// Global ref to track suppression synchronously (avoids race conditions with state updates)
// Default to TRUE (suppressed) - will be enabled after initial page load
let globalSuppressModal = true;

export function isFeatureModalSuppressed() {
  return globalSuppressModal;
}

export function suppressFeatureModalGlobal(value) {
  globalSuppressModal = value;
}

// Auto-enable modal after initial load (5 seconds delay)
// This allows all dashboard components to load without showing modal
if (typeof window !== 'undefined') {
  setTimeout(() => {
    globalSuppressModal = false;
    console.log('[FeatureModal] Suppression window ended - modals enabled');
  }, 5000);
}
